import {
  judgeTesterOutputSchema,
  judgeTesterRequestSchema,
  type JudgeTesterRequest,
  type JudgeTesterOutput,
} from "@shared/judge/schema.ts";

import { defineContractFromMeta } from "@shared/functions.ts";

const CONTRACT_NAME = "judge-tester";

const JudgeTester = defineContractFromMeta({
  name: CONTRACT_NAME,
  meta: import.meta,
  input: judgeTesterRequestSchema,
  output: judgeTesterOutputSchema,
});

export default JudgeTester;
export type JudgeTesterContract = typeof JudgeTester;
export type JudgeTesterInput = JudgeTesterRequest;
export type { JudgeTesterOutput };
